import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { baseUrl } from '../utils';
import axios from 'axios';

const initialState = {
  loading: false,
  appointmentData: [],
  error: false,
};
let token = localStorage.getItem('x-auth-token');
export const getAppointmentData = createAsyncThunk('getAppointmentData', async () => {
  try {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/mental-health-appointment/booking-list`,
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
});

export const getAppointmentsWithFilter = createAsyncThunk(
  'getAppointmentsWithFilter',
  async (updatedFilters) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${baseUrl}/mental-health-appointment/booking-list?status=${updatedFilters.status}&mode=${updatedFilters.mode}`,
        headers: {
          Accept: '*/*',
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
);

export const confirmAppointment = createAsyncThunk(
  'confirmAppointment',
  async (selectedAppointment) => {
    if (selectedAppointment.consultation_mode === 'Online') {
      const { appointment_info } = selectedAppointment;
      const values = {
        appointment_info,
      };
      console.log(values);
      try {
        const response = await axios({
          method: 'PATCH',
          data: JSON.stringify(values),
          url: `${baseUrl}/mental-health-appointment/${selectedAppointment.appointment_id}/status`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        return response;
      } catch (error) {
        console.log(error);
      }
    } else if (selectedAppointment.consultation_mode === 'Offline') {
      const { appointment_info } = selectedAppointment;
      const values = {
        appointment_info,
      };
      try {
        const response = await axios({
          method: 'PATCH',
          data: JSON.stringify(values),
          url: `${baseUrl}/mental-health-appointment/${selectedAppointment.appointment_id}/status`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        return response;
      } catch (error) {
        console.log(error);
      }
    }
  },
);

export const declineAppointment = createAsyncThunk(
  'declineAppointment',
  async (selectedAppointment) => {
    try {
      const { note } = selectedAppointment;
      const values = { note };
      const response = await axios({
        method: 'PATCH',
        data: JSON.stringify(values),
        url: `${baseUrl}/mental-health-appointment/${selectedAppointment.appointment_id}/denied`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('x-auth-token')}`,
        },
      });
      // const { data } = response;
      // if (data?.api.responseCode === 2030) {
      //   appointmentList();
      // }
      return response;
    } catch (error) {
      return;
    }
  },
);

export const appointmentSlice = createSlice({
  name: 'appointment',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAppointmentData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAppointmentData.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.data.api.responseCode === 2040) {
        state.appointmentData = action.payload?.data.result.content;
      }
    });
    builder.addCase(getAppointmentData.rejected, (state) => {
      state.loading = false;
      state.appointmentData = [];
    });
    builder.addCase(getAppointmentsWithFilter.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAppointmentsWithFilter.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.data.api.responseCode === 2040) {
        state.appointmentData = action.payload?.data.result.content;
      } else if (action.payload?.data.api.responseCode === 3410) {
        state.appointmentData = [];
      }
      console.log(state.appointmentData);
    });
    builder.addCase(getAppointmentsWithFilter.rejected, (state) => {
      state.loading = false;
      state.appointmentData = [];
    });
    builder.addCase(confirmAppointment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(confirmAppointment.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.data.api.responseCode === 2030) {
        console.log(state.appointmentData);
      }
      console.log(action.payload, state.appointmentData);
    });
    builder.addCase(confirmAppointment.rejected, (state) => {
      state.loading = false;
      state.appointmentData = [];
    });
    builder.addCase(declineAppointment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(declineAppointment.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.data.api.responseCode === 2030) {
        console.log(state.appointmentData);
      }
    });
    builder.addCase(declineAppointment.rejected, (state) => {
      state.loading = false;
      state.appointmentData = [];
    });
  },
});

export default appointmentSlice.reducer;
